// const moduleB = () => {
//   console.log("component other");
// };
import { ComponentsManager, Component, EventBus } from '../core/smpl-components.js'

import { gsap } from 'gsap'

class VideoEmbedController {
	constructor(options) {
		this.options = {
			playOnCoverClick: true,
			coverFadeDuration: 0.5,
			loadFallbackMs: 1200,
			...options,
		}

		this.elIframe = options.elIframe
		this.elButton = options.elButton
		this.elCover = options.elCover

		this.isLoading = false
		this.hasStarted = false
		this.loadFallbackTimer = null

		this.bndBtnClick = this.onBtnClick.bind(this)

		if (this.options.playOnCoverClick && this.elCover) {
			this.elCover.addEventListener('click', this.bndBtnClick)
		}
		if (this.elButton) {
			this.elButton.addEventListener('click', this.bndBtnClick)
		}
	}

	onBtnClick(ev) {
		if (ev) {
			ev.preventDefault()
			ev.stopPropagation()
		}

		if (this.hasStarted || this.isLoading) {
			return
		}

		this.isLoading = true
		this.disablePlayUi()

		const rawSrc = this.elIframe?.getAttribute('data-src') || this.elIframe?.getAttribute('src')
		if (!rawSrc) {
			this.revealVideo()
			return
		}

		const nextSrc = this.buildAutoplaySrc(rawSrc)

		const onLoaded = () => {
			this.cleanupLoadHandlers()
			this.revealVideo()
		}

		this._onIframeLoad = onLoaded
		this.elIframe.addEventListener('load', this._onIframeLoad, { once: true })

		this.loadFallbackTimer = setTimeout(() => {
			this.cleanupLoadHandlers()
			this.revealVideo()
		}, this.options.loadFallbackMs)

		if (!this.elIframe.getAttribute('src') || this.elIframe.getAttribute('src') !== nextSrc) {
			this.elIframe.setAttribute('src', nextSrc)
		} else {
			onLoaded()
		}
	}

	buildAutoplaySrc(src) {
		let url

		try {
			url = new URL(src, window.location.origin)
		} catch (e) {
			return src
		}

		const host = url.hostname.toLowerCase()
		const isYoutube = host.includes('youtube.com') || host.includes('youtu.be')
		const isVimeo = host.includes('vimeo.com')

		if (isYoutube) {
			url.searchParams.set('autoplay', '1')
			url.searchParams.set('playsinline', '1')
			url.searchParams.set('rel', '0')
		} else if (isVimeo) {
			url.searchParams.set('autoplay', '1')
		} else {
			url.searchParams.set('autoplay', '1')
		}

		return url.toString()
	}

	disablePlayUi() {
		if (this.elButton) {
			this.elButton.disabled = true
			this.elButton.setAttribute('aria-busy', 'true')

			gsap.to(this.elButton, { opacity: 0, duration: 0.2, ease: 'power3.out' })
		}
	}

	enablePlayUi() {
		if (this.elButton) {
			this.elButton.disabled = false
			this.elButton.removeAttribute('aria-busy')

			gsap.to(this.elButton, { opacity: 1, duration: 0.2, delay: 0.5, ease: 'power3.out' })
		}
	}

	revealVideo() {
		this.hasStarted = true
		this.isLoading = false
		this.enablePlayUi()

		if (!this.elCover) {
			return
		}

		gsap.to(this.elCover, {
			opacity: 0,
			duration: this.options.coverFadeDuration,
			onComplete: () => {
				this.elCover.style.display = 'none'
			},
		})
	}

	cleanupLoadHandlers() {
		if (this.loadFallbackTimer) {
			clearTimeout(this.loadFallbackTimer)
			this.loadFallbackTimer = null
		}

		if (this._onIframeLoad && this.elIframe) {
			this.elIframe.removeEventListener('load', this._onIframeLoad)
			this._onIframeLoad = null
		}
	}

	reset({ showCover = true } = {}) {
		this.cleanupLoadHandlers()

		if (this.elIframe) {
			// unload player to guarantee stop without API
			this.elIframe.removeAttribute('src')
			if (this.initialDataSrc) {
				this.elIframe.setAttribute('data-src', this.initialDataSrc)
			}
		}

		this.hasStarted = false
		this.isLoading = false
		this.enablePlayUi()

		if (showCover && this.elCover) {
			this.elCover.style.display = ''
			this.elCover.style.opacity = '1'
		}
	}
	destroy() {
		this.cleanupLoadHandlers()

		if (this.elButton) {
			this.elButton.removeEventListener('click', this.bndBtnClick)
		}

		if (this.options.playOnCoverClick && this.elCover) {
			this.elCover.removeEventListener('click', this.bndBtnClick)
		}
	}
}

// -------------------------------------------------------------------------- //
export default class extends Component {
	prepare() {
		const elIframe = this.element.querySelector('iframe')
		const elCover = this.element.querySelector('.js-video-embed-cover')
		const elButton = this.element.querySelector('.js-video-embed-play')
		if (elIframe) {
			this.videoEmbedController = new VideoEmbedController({
				elIframe: elIframe,
				elButton: elButton,
				elCover: elCover,
			})
		}
	}
	mount() {}
	unmount() {
		if (this.videoEmbedController) {
			this.videoEmbedController.destroy()
			this.videoEmbedController = null
		}
	}

	resetVideo() {
		if (this.videoEmbedController) {
			this.videoEmbedController.reset()
		}
	}
}
